<template>
  <div class="main-container">
    <b-form-group
      label-cols-lg="3"
    >
      <b-form-checkbox
        :unchecked-value=false
        v-model="rawMode"
      >
        Raw HTML mode
      </b-form-checkbox>
    </b-form-group>
    <div v-if="rawMode" class="raw-container">
      <b-row class='mb-3'>
        <b-col md='6'><uploader
          :minimal-mode='true'
          :src="uploaderObject.url"
          @uploaded="uploaded"
        /></b-col>
        <b-col md='6'><select class="form-control" @change="addSubstitution">
          <option disabled hidden selected :value="null">Substitutions</option>
          <optgroup v-for="(tags, label) in substitutionTagsV2" :key="label" :label="label">
            <option
              v-for="tag in tags"
              :key="tag.value"
              :value="tag.value"
            >{{tag.label}}</option>
          </optgroup>
        </select></b-col>
      </b-row>
      <VueCodeEditor
        ref='codeEditorV2'
        v-model="code"
        @init="editorInit"
        lang="html"
        theme="monokai"
        width="100%"
        height="500px"
        :options="{
        enableBasicAutocompletion: true,
        enableLiveAutocompletion: true,
        fontSize: 14,
        highlightActiveLine: true,
        enableSnippets: true,
        showLineNumbers: true,
        tabSize: 2,
        showPrintMargin: false,
        showGutter: true,
    }"
        :commands="[
        {
            name: 'save',
            bindKey: { win: 'Ctrl-s', mac: 'Command-s' },
            exec: null,
            readOnly: true,
        },
    ]"
      />
    </div>
    <div v-else class="document-container">
      <document-section
        :obj="document.header"
        :substitution-tags="groupedSubstitutionTags"
        :expanded="expandHeader"
        title="Header"
      ></document-section>

      <document-section
        :obj="document.body"
        :substitution-tags="substitutionTagsV2"
        :expanded="expandBody"
        title="Body"
      ></document-section>

      <document-section
        :obj="document.footer"
        :substitution-tags="substitutionTagsV2"
        :expanded="expandFooter"
        title="Footer"
      ></document-section>
    </div>
  </div>
</template>

<script>
import VueCodeEditor from 'vue2-code-editor';
import { mapState, mapGetters, mapMutations } from 'vuex'
import { mappedColumns } from '../../const/dealFilterConstants'
import DocumentSection from './DocumentSection'
import Uploader from '../Uploader'
export default {
  name: 'DocumentContainer',

  components: {
    DocumentSection,
    VueCodeEditor,
    Uploader
  },

  props: [
    'expandSections'
  ],
  mounted(){
    if(this.previewHtml)
      this.code = this.previewHtml
    if(this.template) {
      this.rawMode = this.template.rawMode
      if(this.rawMode){
        if(this.$route.name === 'stage-template')
          this.code = this.stage.template_html
        else
          this.code = this.template.template_html
      }
    }
  },
  computed: {
    ...mapState('emails', [
      'document','previewHtml'
    ]),
    ...mapState('templates', [
      'template'
    ]),
    ...mapState('stages', [
      'stage'
    ]),

    ...mapGetters('substitution_tags', [
      'groupedSubstitutionTags'
    ]),
    substitutionTagsV2() {
      let remap = {}
      for (let k of mappedColumns) {
        const newOptions = k.subOptions.map(n => {
          return {
            'label': n.label,
            'value': `##__${n.id}__##`,
            'type': `${k.id}`
          }
        })
        remap[k.id] = newOptions
      }
      return remap
    },
    expandHeader() {
      return this.expandSections && this.expandSections.indexOf('header') > -1
    },

    expandBody() {
      return this.expandSections && this.expandSections.indexOf('body') > -1
    },

    expandFooter() {
      return this.expandSections && this.expandSections.indexOf('footer') > -1
    }
  },
  data() {
    return {
      uploaderObject: {
        url: ''
      },
      rawMode: false,
      code: '',
      cmOptions: {
        // codemirror options
        tabSize: 2,
        mode: 'text/html',
        theme: 'monokai',
        lineNumbers: true,
        line: true,
        autofocus: true,
        indentWithTab: true
        // more codemirror options, 更多 codemirror 的高级配置...
      }
    }
  },
  methods: {
    editorInit: function () {
      // vue2-code-editor/node_modules/
      require('brace/ext/language_tools') //language extension prerequsite...
      require('brace/mode/html') //language
      require('brace/theme/monokai')
    },
    addSubstitution: function(e) {
      if (!e.target.value) return
      this.$refs.codeEditorV2.editor.insert(e.target.value)
    },
    uploaded(v){
      this.uploaderObject.url = v
      this.$refs.codeEditorV2.editor.insert(v)
    },
    ...mapMutations('emails',['updateMode','updatePreviewHtml']),
    ...mapMutations('stages',['updateAttribute']),
    ...mapMutations('templates',['updateTemplate'])
  },
  watch: {
    code(v){
     if(v){
       this.updatePreviewHtml(v)
       const newTemplate = this.template
       newTemplate.document_html = v
       newTemplate.rawModeContent = v
       newTemplate.rawMode = true
       this.updateAttribute({ attribute: 'template_html', value: v })
       this.updateTemplate(newTemplate)
     }
    },
    template(){
      this.rawMode = this.template.rawMode
    },
    rawMode(v){
      this.updateMode(v)
    },
  }
}
</script>
<style>
.ace_editor, .ace_editor *{
  font-family: "Monaco", "Menlo", "Ubuntu Mono", "Droid Sans Mono", "Consolas", monospace !important;
  font-size: 12px !important;
  font-weight: 400 !important;
  letter-spacing: 0 !important;
}
</style>
